export const ERRORS = {
  cookie:
    'Para la autenticacion con Google debe permitir las cookies en su browser y despues refresque la página',
  common:
    'Lo sentimos; ocurrio un error contactando los servidores de Google por favor vuelva a intentarlo',
};
